// extracted by mini-css-extract-plugin
export default {"label":"_Label_label__lBO+A","formLabel":"_Label_formLabel__-s3ul","formExplainer":"_Label_formExplainer__fN9Nn"};